function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKoreroNavLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 189.9746 78.4298",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "logoMark_PathItem_",
    "data-name": "logoMark <PathItem>",
    x: 58.2538,
    y: 10.0079,
    width: 13.7231,
    height: 3.8201,
    style: {
      fill: "#55d8c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_",
    "data-name": "logoMark <CompoundPathItem>",
    d: "M115.5788,35.459a7.6348,7.6348,0,0,1-13.4557-3.2264h14.9442l-.0015.0064h4.8306a12.1968,12.1968,0,0,0,.0792-1.3683,12.3052,12.3052,0,1,0-1.6744,6.1384Zm-5.9836-12.0585a7.6181,7.6181,0,0,1,7.0143,4.587H102.581A7.618,7.618,0,0,1,109.5952,23.4005Z",
    style: {
      fill: "#19394f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_2",
    "data-name": "logoMark <CompoundPathItem>",
    d: "M65.1153,43.1167A12.2467,12.2467,0,1,1,77.4959,30.8708,12.3276,12.3276,0,0,1,65.1153,43.1167Zm0-19.7162a7.4715,7.4715,0,1,0,7.6049,7.47A7.547,7.547,0,0,0,65.1153,23.4005Z",
    style: {
      fill: "#19394f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_CompoundPathItem_3",
    "data-name": "logoMark <CompoundPathItem>",
    d: "M153.84,43.1167a12.2467,12.2467,0,1,1,12.3805-12.2459A12.3275,12.3275,0,0,1,153.84,43.1167Zm0-19.7162a7.4715,7.4715,0,1,0,7.6049,7.47A7.5471,7.5471,0,0,0,153.84,23.4005Z",
    style: {
      fill: "#19394f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_2",
    "data-name": "logoMark <PathItem>",
    d: "M39.6136,25.4033A31.8762,31.8762,0,0,0,50.0715,10H45.04a27.0623,27.0623,0,0,1-9.5469,12.5392l-2.52,1.8118V10H28.3043V42.5653h4.6694v-16.11l2.5192,1.8125A27.0728,27.0728,0,0,1,45.6078,42.5232h4.9441A31.8894,31.8894,0,0,0,39.6136,25.4033Z",
    style: {
      fill: "#19394f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_3",
    "data-name": "logoMark <PathItem>",
    d: "M65.0288,68.43l-2.665-3.7035a20.7415,20.7415,0,0,0-16.798-8.6093H35.468A25.497,25.497,0,0,1,10,30.6488V26.3271h4.7757v4.3217A20.7157,20.7157,0,0,0,35.468,51.3413H45.5658a25.5363,25.5363,0,0,1,19.463,9.043,25.5372,25.5372,0,0,1,19.4628-9.043h70.0148a20.7158,20.7158,0,0,0,20.6925-20.6925V26.3271h4.7757v4.3217A25.4971,25.4971,0,0,1,154.5064,56.117H84.4916A20.7409,20.7409,0,0,0,67.694,64.7263Z",
    style: {
      fill: "#55d8c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_4",
    "data-name": "logoMark <PathItem>",
    d: "M94.974,18.3193a11.22,11.22,0,0,0-7.2086,3.7494l.0056-3.47-4.7757-.0076-.0383,23.955,4.7756.0077.02-12.2243a7.2072,7.2072,0,0,1,6.4324-7.1924,5.4389,5.4389,0,0,1,.7817-.03Z",
    style: {
      fill: "#19394f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "logoMark_PathItem_5",
    "data-name": "logoMark <PathItem>",
    d: "M139.3157,18.3193a11.22,11.22,0,0,0-7.2086,3.7494l.0055-3.47-4.7756-.0076-.0383,23.955,4.7756.0077.02-12.2243a7.2072,7.2072,0,0,1,6.4324-7.1924,5.4389,5.4389,0,0,1,.7817-.03Z",
    style: {
      fill: "#19394f"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoreroNavLogo);
export default __webpack_public_path__ + "static/media/koreroNavLogo.0fd55c5d8dddcde92f2e43fd4dca3610.svg";
export { ForwardRef as ReactComponent };